import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label } from "@air/primitive-label";
import { VisuallyHidden } from "@air/primitive-visually-hidden";
import { Slot } from "@radix-ui/react-slot";
import classNames from "classnames";
import { useField } from "formik";
export const FormikField = (param)=>{
    let { className, component, id, isLabelHidden, isErrorHidden, label, name, description, ...restOfProps } = param;
    const formikId = "formik-field-".concat(id);
    const [field, meta] = useField({
        name
    });
    const hasError = !!meta.error && meta.touched;
    const componentProps = {
        hasError,
        ...field
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("relative flex flex-col gap-1", className),
        ...restOfProps,
        children: [
            !!label && isLabelHidden ? /*#__PURE__*/ _jsx(VisuallyHidden, {
                children: /*#__PURE__*/ _jsx(Label, {
                    htmlFor: formikId,
                    size: "small",
                    children: label
                })
            }) : /*#__PURE__*/ _jsx(Label, {
                htmlFor: formikId,
                size: "small",
                children: label
            }),
            /*#__PURE__*/ _jsx(Slot, {
                id: formikId,
                ...componentProps,
                children: component
            }),
            !hasError && description && /*#__PURE__*/ _jsx("p", {
                className: "absolute top-full w-full translate-y-0.5 text-12 text-grey-10",
                children: description
            }),
            hasError && !isErrorHidden && /*#__PURE__*/ _jsx("div", {
                "data-testid": "FORM_ERROR",
                "data-fieldid": id,
                className: "form-field-error absolute top-full w-full translate-y-0.5 text-12 text-red-9",
                children: meta.error
            })
        ]
    });
};
